<template>
  <section class="sme-underwriting-container">
    <catering v-if="classId==81"></catering>
    <pure v-else-if="classId==82"></pure>
    <retail-shop v-else-if="classId==83"></retail-shop>
    <beauty-center v-else-if="classId==84"></beauty-center>
    <education-center v-else-if="classId==85"></education-center>
    <hair v-else-if="classId==86"></hair>
    <medical-center v-else-if="classId==88"></medical-center>
  </section>
</template>

<script>
import catering from './sme/catering/underwriting'
import pure from './sme/pure-office/underwriting'
import retailShop from './sme/retail-shop/underwriting'
import beautyCenter from './sme/beauty-center/underwriting'
import educationCenter from './sme/education-center/underwriting'
import hair from './sme/hair/underwriting'
import medicalCenter from './sme/medical-center/underwriting'
import {mapState} from 'vuex'
import {productAPiPath, smeClassId} from '@/utils/smePath'

export default {
  name: 'smeUnderwriting',
  components:{
    catering,
    pure,
    retailShop,
    beautyCenter,
    educationCenter,
    hair,
    medicalCenter
  },
  computed:{
    classId(){
      let {type} = this.$route.params
      return smeClassId[type]
    }
  }
}
</script>

<style scoped lang="scss">
  .sme-underwriting-container{
    margin: -20px;
    padding: 30px 90px;
    background: #fff;
    min-height: 100vh;
    .abs-top-right{
      top: 30px;
      right: 70px;
    }
  }
</style>
